import { LinearGradient } from 'expo-linear-gradient';
import React, { useEffect, useRef } from 'react';
import {
  StyleProp,
  ViewStyle,
  Animated,
  View,
  StyleSheet,
  Dimensions,
} from 'react-native';
import { useTheme } from 'react-native-paper';

import {
  bc,
  width as widthStyleUtil,
  height as heightStyleUtil,
  borderRadius,
} from '../../style-utils';

export type SkeletonProps = {
  style?: StyleProp<ViewStyle>;
  radius?: number;
  width?: number | string;
  height?: number | string;
  backgroundColor?: string;
  gradientColor?: string;
};

const AnimatedLinearGradient = Animated.createAnimatedComponent(LinearGradient);

export const Skeleton: React.FC<SkeletonProps> = ({
  style,
  radius,
  width = '100%',
  height = 22,
  backgroundColor,
  gradientColor,
}) => {
  const { colors } = useTheme();
  const animatedValue = useRef(new Animated.Value(0)).current;
  const screenWidth = Dimensions.get('window').width;
  backgroundColor = backgroundColor ?? colors.light1;
  gradientColor = gradientColor ?? colors.border;

  useEffect(() => {
    Animated.loop(
      Animated.sequence([
        Animated.timing(animatedValue, {
          toValue: 1,
          duration: 2000,
          useNativeDriver: true,
        }),
      ])
    ).start();
  }, [animatedValue]);

  const translateX = animatedValue.interpolate({
    inputRange: [0, 1],
    outputRange: [-screenWidth, screenWidth],
  });

  return (
    <View
      style={[
        bc(backgroundColor),
        widthStyleUtil(width),
        heightStyleUtil(height),
        styles.background,
        !!radius && borderRadius(radius),
        style,
      ]}
    >
      <AnimatedLinearGradient
        colors={[
          backgroundColor,
          backgroundColor,
          gradientColor,
          backgroundColor,
          backgroundColor,
        ]}
        end={{ x: 1, y: 0 }}
        start={{ x: 0, y: 0 }}
        style={[
          widthStyleUtil(screenWidth),
          heightStyleUtil(height),
          transformStyle(translateX),
        ]}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  background: {
    overflow: 'hidden',
    borderRadius: 4,
  },
});

const transformStyle = (translateX: any) => {
  const { transform } = StyleSheet.create({
    // eslint-disable-next-line react-native/no-unused-styles
    transform: {
      transform: [{ translateX }],
    },
  });

  return transform;
};
